/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
function shallowequal(object1, object2) {
  if (object1 === object2) {
    return true;
  }
  if ((0, _typeof2.default)(object1) !== 'object' || object1 === null || (0, _typeof2.default)(object2) !== 'object' || object2 === null) {
    return false;
  }
  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  var equal = true;
  for (var i = 0, len = keys1.length; i < len; i++) {
    var key = keys1[i];
    if (object1[key] !== object2[key]) {
      equal = false;
      break;
    }
  }
  return equal;
}
var _default = shallowequal;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/react-notify-resize/src/shallowequal.js
// module id = 753
// module chunks = 0